<template lang="pug">
.comments
    .comments-title
        h2 {{$t(`${baseTranslationPath}.comments_title`)}}

    .comment-field
        label {{ $t(`${baseTranslationPath}.drop_a_comment`) }}
        aiq-input(v-model="newComment"
            :max-length="250"
            :max-width="250"
            type="textarea"
        )
        .comment-btn
            aiq-button(type="primary" class="group-btn" @click="addComment(null, 'comment')") {{ $t(`${baseTranslationPath}.add_comment`) }}

    .comment-section(v-for="comment in comments" :key="comment.id")
        .comment
            .comment-header
                aiq-image(:src="avatar(comment)" :key="avatar(comment)")
            .comment-content
                .comment-title
                    b.user {{ firstName(comment) }} {{ lastName(comment) }} {{ isDocumentRejected(comment) === 'reject' ? '(' + $t(`${baseTranslationPath}.rejected`) + ')' : '' }}
                    aiq-timeago.time-ago(:since="comment.created_at" :minTime="0")
                p.msg-content {{comment.content}}
        .comment-delete(v-if="canDelete(comment)")
            aiq-button(type="danger" @click="deleteComment(comment)") {{ $t('global.delete') }}
        .reply-section
            .replies
                .reply(v-for="reply in comment.replies" :key="reply.id")
                    .reply-comment
                        .comment-header
                            aiq-image(:src="avatar(reply)" :key="avatar(reply)")
                        .reply-content
                            .comment-title
                                b.user {{ firstName(reply) }} {{ lastName(reply) }}
                                aiq-timeago.time-ago(:since="reply.created_at" :minTime="0")
                            p.msg-content {{reply.content}}

            .reply-field
                aiq-input(
                    v-model="replies[comment.id]"
                    :max-length="250"
                    type="textarea"
                )
                .comment-btn
                    aiq-button(
                        type="primary"
                        class="group-btn"
                        @click="addComment(comment, 'reply', replies[comment.id])"
                    ) {{ $t(`${baseTranslationPath}.add_reply`) }}


</template>
<script>
import { defaultProfile } from '@/libs';
import get from 'lodash/get';
import { mapState } from 'vuex';

export default {
  name: 'ControlListComments',
  data() {
    return {
      baseTranslationPath: 'settings_tab.admin_tab.smart_control.control_list_manage',
      newComment: '',
      replies: {},
    };
  },
  props: {
    comments: {
      type: Array,
      default: () => [],
    },
    documentId: {
      type: String,
      default: null,
    },
  },
  computed: {
    ...mapState({
      agent: state => state.agent.profile,
    }),
  },
  emits: ['addComment', 'deleteComment'],
  methods: {
    avatar(comment) {
      return get(comment, 'agent.picture.payload.url', defaultProfile.picture);
    },

    firstName(comment) {
      return get(comment, 'agent.profile.first_name', defaultProfile.first_name);
    },
    isDocumentRejected(comment) {
      return get(comment, 'payload.type', '');
    },

    canDelete(comment) {
      const agent_id = get(comment, 'agent_id');
      const logged_in_agent_id = get(this.agent, 'id');
      return agent_id === logged_in_agent_id;
    },

    lastName(comment) {
      return get(comment, 'agent.profile.last_name', defaultProfile.last_name);
    },
    addComment(comment, type, reply = '') {
      if (type === 'reply') {
        this.replies[comment.id] = '';
        const parent_id = get(comment, 'id');
        this.$emit('addComment', { id: this.documentId, comment: reply, parent_id });
      } else if (type === 'comment') {
        this.$emit('addComment', { id: this.documentId, comment: this.newComment });
        this.newComment = '';
      }
    },

    async confirmDelete() {
      try {
        await this.$aiq.confirm(
          this.$t(`${this.baseTranslationPath}.delete_confirm.title`),
          this.$t(`${this.baseTranslationPath}.delete_confirm.message`),
        );
        return true;
      } catch {
        return false;
      }
    },
    async deleteComment(comment) {
      if (!(await this.confirmDelete())) {
        return;
      }
      this.$emit('deleteComment', { id: this.documentId, comment_id: comment.id });
    },
  },
};
</script>
<style lang="scss" scoped>
@import 'src/styles/aiq-variables.scss';

:deep(.el-textarea__inner) {
  height: 150px;
}

.comment-delete {
    display: flex;
    justify-content: flex-end;
    padding-right: 10px;
}

.comments {
    margin-top: 20px;
    padding-bottom: 150px;
}

.comment-btn {
    padding-top: 20px;
    display: flex;
    justify-content: flex-end;
}

.comment-header {
    padding-top: 20px;
}
.comment-field {
    margin-top: 10px;
    padding-right: 20px;
}

.reply-section {
  margin-left: 60px;
  border-left: 2px solid var(--aiq-table-border);
  padding-left: 20px;
  margin-top: 10px;
}

.replies {
  display: flex;
  flex-direction: column;
}

.reply-field {
    margin-top: 10px;
    padding-left: 10px;
    padding-right:10px;
    width: 100% !important;
    justify-content: flex-end;
}

.comment {
    display: flex;
    margin-bottom: 10px;
}

.comment-section {
    margin-top: 10px;
}

.comment-title {
    display: flex;
    justify-content: space-between;
}

.time-ago {
    justify-content: flex-end;
    padding-right: 10px;
}
img {
      width: 28px;
      height: 28px;
      border-radius: 50%;
}

.reply-comment {
    margin-left: 40px;
    display: flex;
    align-items: flex-start;

}

.profile-name {
      white-space: nowrap;
      overflow: hidden;
      min-width: 0px;
      text-overflow: ellipsis;
      line-height: 28px;
}

.msg-content {
    padding-top: 10px;
    padding-left: 15px;
}

.reply-content {
    margin-bottom: 10px;
    margin-top: 10px;
    margin-left: 30px;
    margin-right: 30px;
    border-radius: 10px;
    padding-top: 20px;
    padding-left: 10px;
    height: 140px;
    width: 100%;
    border: 1px solid var(--aiq-table-border);
    background-color: var(--aiq-table-border);
    overflow-y: auto;
    max-width: 600px;
}
.comment-content {
    margin-bottom: 10px;
    margin-top: 10px;
    margin-left: 30px;
    margin-right: 30px;
    border-radius: 10px;
    padding-top: 20px;
    padding-left: 10px;
    height: 150px;
    width: 100%;
    border: 1px solid var(--aiq-table-border);
    background-color: var(--aiq-table-border);
    overflow-y: auto;
}
</style>